import React, { useEffect, useState } from 'react';
import { Paper } from 'material-ui';
import IconButton from 'material-ui/IconButton';
import ArrowIcon from 'material-ui/svg-icons/navigation/arrow-upward';
import CopyIcon from 'material-ui/svg-icons/content/content-copy';
import { elementsMapping as _elementsMapping } from './helpers';
import helpers from 'helpers';

function Sidebar({ issue, user }) {
    const [userElements, setUserElements] = useState({});
    const [systemElements, setSystemElements] = useState({});
    const [elementsMapping, _e] = useState(_elementsMapping);
    const [hasUserPrivileges, _s] = useState(helpers.isDevAllowed(user.email))

    useEffect(() => {
        issue.userElements && setUserElements(issue.userElements);
        issue.systemElements && setSystemElements(issue.systemElements);
    }, [issue]);
    
    const renderElements = (elements) => {
        const rows = [];

        Object.entries(elements).map(([key, value]) => {
            value.forEach(item => {
                if (typeof item === 'string') {
                    rows.push(
                        <Row 
                            key={item}
                            value={item}
                            element={elementsMapping[key]}
                        />
                    );    
                } else {
                    const { refNo, imoNumber, _id } = item;
                    rows.push(
                        <Row 
                            key={_id}
                            _id={
                                (elementsMapping[key].customId && item[elementsMapping[key].customId]) ||
                                _id
                            }
                            value={refNo || imoNumber || _id}
                            element={elementsMapping[key]}
                            user={issue.addedBy}
                        />
                    );
                }
            });
        })

        return rows;
    };

    return (
        <div style={{ display: 'flex' }}>
            <Paper 
                className='elements'  
                zDepth={1}
            >
                <p id='block-name'>Elements</p>
                <div className='elements-list'>
                    { renderElements(userElements) }
                    { renderElements(systemElements) }
                </div>
            </Paper>
        </div>
    );
}

export default React.memo(Sidebar);

/**
 * 
 * @param {string} redirectUrl 
 * @param {string} userId 
 */
async function loginInNewPage(redirectUrl, userId) {
    const session = await helpers.prepareOneTimeAuthSession(userId);

    const link = `${VARS.platformUrl}/api/v1/auth/loginAs?key=${session.key}&&redirect=${redirectUrl}`;

    const form = document.createElement("form");
    form.method = "POST";
    form.action = link;
    form.target = "_blank";

    document.body.appendChild(form);

    form.submit();
    form.remove();
}

/**
 * @param {{ 
 *  value?: string, 
 *  element: { label: string, canOpenOnMain?: boolean, getUrl: (_id: string) => string },
 *  _id?: string,
 *  user?: { _id: string, email: string }
 * }} props 
 */
function Row({ element: { label, canOpenOnMain, getUrl }, value, _id, user }) {

    const hasUrl = Boolean(getUrl);

    const onClick = () => {
        const redirectUrl = getUrl(_id);

        if (canOpenOnMain) {
            return loginInNewPage(redirectUrl, user._id);
        } 

        return window.open(redirectUrl, "_blank");
    }

    return (
        <div
            className='elements-list-row'
        >
            <span className='label'>{label}: {value}
                <IconButton 
                    style={{ padding: 0, marginLeft: '10px' }} 
                    onClick={() => navigator.clipboard.writeText(value)}
                    iconStyle={{ height: '18px', width: '18px', display: 'flex' }}    
                >
                    <CopyIcon className='icon-copy' color='#666666' style={{ height: '18px', width: '18px' }} />
                </IconButton>
            </span>
            
            <IconButton 
                disabled={!canOpenOnMain} 
                className='button'
                style={{ opacity: hasUrl ? 1 : 0.2 }}
            >
                <ArrowIcon  
                    className='icon'
                    onClick={onClick}
                />
            </IconButton>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/Sidebar.jsx